import { useEffect, useState } from 'react'
import type { IDockviewPanelHeaderProps } from 'dockview'
import { PANEL_ICON, IconX } from '../ui/icons'

// Custom tab: panel icon + title + close — matches the strawman header chrome.
export function PanelTab(props: IDockviewPanelHeaderProps) {
  const Icon = PANEL_ICON[props.api.id]
  const [active, setActive] = useState(props.api.isActive)
  useEffect(() => {
    const d = props.api.onDidActiveChange((e) => setActive(e.isActive))
    return () => d.dispose()
  }, [props.api])
  return (
    <div className={active ? 'sb-tab active' : 'sb-tab'}>
      {Icon && <span className="sb-tab-ico"><Icon size={15} stroke={1.75} /></span>}
      <span className="sb-tab-title">{props.api.title}</span>
      <span
        className="sb-tab-close"
        role="button"
        aria-label="close panel"
        onClick={(e) => { e.stopPropagation(); props.api.close() }}
      >
        <IconX size={13} stroke={2} />
      </span>
    </div>
  )
}
